<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete
                        label="Commission Type"
                        variant="outlined" 
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="type_id.value.value"
                        :items="commissionTypes"
                        autocomplete="off"
                        clearable>
                      </v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Sales Commission Report</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :loading="loading"
                  :items-per-page="-1"
                  :search="search"
                  :hover="true"
                  class="elevation-1"
                  density="comfortable"
                  hide-default-footer
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template #item.type="{ item }">
                    <v-chip color="primary" size="small" class="text-capitalize">
                      {{ formatType(item.type) }}
                    </v-chip>
                  </template>

                  <template #item.percentage="{ item }">
                    {{ item.percentage ? item.percentage + '%' : '-' }}
                  </template>

                   <template #item.range="{ item }">
                    <div v-if="item.type === 'tiered'">
                      {{ formatCurrency(item.from_amount) }} -
                      {{ formatCurrency(item.to_amount) }}
                    </div>
                    <div v-else>-</div>
                  </template>

                  <template #item.total_commission="{ item }">
                    {{ formatCurrency(item.total_commission) }}
                  </template>

                  <template #expanded-row="{ item }">
                    <tr>
                      <td colspan="8" class="bg-grey-lighten-4">
                        <v-table>
                          <thead>
                            <tr>
                              <th>Invoice Code</th>
                              <th>Date</th>
                              <th>Customer</th>
                              <th>Total</th>
                              <th>Commission</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="inv in item.invoices || item.details" :key="inv.id">
                              <td>{{ inv.code }}</td>
                              <td>{{ inv.sale_invoice_date || '-' }}</td>
                              <td>{{ inv.customer_name || '-' }}</td>
                              <td>{{ formatCurrency(inv.total) }}</td>
                              <td>{{ formatCurrency(inv.commission_amount) }}</td>
                            </tr>
                          </tbody>
                        </v-table>
                      </td>
                    </tr>
                  </template>

                  <template #tfoot>
                    <tr class="font-weight-bold">
                      <td colspan="6" class="text-center">Grand Total Commission:</td>
                      <td class="text-right">{{ formatCurrency(summary.grand_total_commission) }}</td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { ref } from "vue";
import { useStore } from "vuex";
import * as yup from "yup";
import Axios from "axios";
import { getCommissionReport } from '@/store/api.js'

export default {
  components: {
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    summary: {},
    commissionTypes: [
      { title: "Fixed Percentage", value: "fixed_percentage" },
      { title: "Product Based", value: "product_based" },
      { title: "Profit Based", value: "profit_based" },
      { title: "Tiered", value: "tiered" },
    ],
    headers: [
      { title: "#", key: "index", align: "center" },
      { title: "Code", key: "rule_code", align: "left" },
      { title: "Type", key: "type", align: "left" },
      { title: "Percentage", key: "percentage", align: "center" },
      { title: "Range (If Tiered)", key: "range", align: "center" },
      { title: "From Date", key: "from_date", align: "center" },
      { title: "To Date", key: "to_date", align: "center" },
      { title: "Total Commission", key: "total_commission", align: "right" },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getCustomerMapList.length === 0) {
      this.$store.dispatch("getCustomerMapList");
    }
  },
  computed: {
    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList;
    },
  },
  setup() {

    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label("From Date"),
        to_date: yup.date().nullable().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const type_id = useField("type_id");
    const customer_id = useField("customer_id");
    const invoice_code = useField('invoice_code');
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const reportData = ref([]);
    const summary = ref({});
    const filters = ref({ with_details: false });

    const submit = handleSubmit(async (values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);

      filters.value = {
        type_id: type_id.value.value,
        customer_id: customer_id.value?.value,
        invoice_code: invoice_code.value?.value,
        from_date: values.from_date,
        to_date: values.to_date,
        with_details: filters.value.with_details,
      };

      try {
        const { data } = await Axios.post(getCommissionReport, filters.value )
        reportData.value = data.data
        summary.value = data.summary;
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    });


    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 });

    const formatType = (type) => {
      switch (type) {
        case "fixed_percentage":
          return "Fixed %";
        case "product_based":
          return "Product Based";
        case "profit_based":
          return "Profit Based";
        case "tiered":
          return "Tiered Range";
        default:
          return type;
      }
    };

    return {
      submit,
      from_date,
      to_date,
      type_id,
      customer_id,
      invoice_code,
      reportData,
      summary,
      filters,
      formatCurrency,
      formatType,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$router.push({
        name: "add-crm-proposal",
        query: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Sale Statement", "sale_statement_reports_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });
      this.$exportTableToExcel(data, "sale_statement_reports_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "sale_statement_reports_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
